module.exports = __webpack_public_path__ + "img/1688주문서다운로드.09e16c6e.png";